import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { forwardRef } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var DesktopNavigation = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return _jsx(Wrapper, {
    ref: ref,
    children: children
  });
});

var Wrapper = /*#__PURE__*/_styled("nav", true ? {
  target: "e1p314cx0"
} : {
  target: "e1p314cx0",
  label: "Wrapper"
})(true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvRGVza3RvcE5hdmlnYXRpb24vRGVza3RvcE5hdmlnYXRpb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVEwQiIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL05hdmlnYXRpb24yL0Rlc2t0b3BOYXZpZ2F0aW9uL0Rlc2t0b3BOYXZpZ2F0aW9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGZvcndhcmRSZWYsIHR5cGUgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IERlc2t0b3BOYXZpZ2F0aW9uID0gZm9yd2FyZFJlZjxIVE1MRWxlbWVudCwgUHJvcHNXaXRoQ2hpbGRyZW4+KCh7IGNoaWxkcmVuIH0sIHJlZikgPT4gKFxuICA8V3JhcHBlciByZWY9e3JlZn0+e2NoaWxkcmVufTwvV3JhcHBlcj5cbikpXG5cbmNvbnN0IFdyYXBwZXIgPSBzdHlsZWQubmF2YFxuICBwb3NpdGlvbjogc3RpY2t5O1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHotaW5kZXg6IDk5OTtcbiAgd2lkdGg6IDEwMCU7XG5gXG5cbmV4cG9ydCBkZWZhdWx0IERlc2t0b3BOYXZpZ2F0aW9uXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default DesktopNavigation;